var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M37.454 10.82A10.55 10.55 0 0 1 32.661 2h-7.565l-.012 30.316c-.127 3.395-2.921 6.12-6.346 6.12a6.3 6.3 0 0 1-2.95-.731 6.36 6.36 0 0 1-3.41-5.628 6.367 6.367 0 0 1 6.36-6.36c.654 0 1.282.109 1.875.294V18.29a14 14 0 0 0-1.876-.136c-7.677 0-13.923 6.246-13.923 13.924 0 4.71 2.353 8.88 5.945 11.4A13.84 13.84 0 0 0 18.739 46c7.676 0 13.922-6.246 13.922-13.923V16.704a18 18 0 0 0 10.525 3.384v-7.565c-2.113 0-4.08-.627-5.732-1.704"
  })));
};
export default SvgTiktok;